<template>
  <nav>
    <AlertMessages v-if="alertValue" :alert-type="alertType" :alert-msg="alertMsg" @reset="alertValue = false" />
    <DashboardHeader />
    <v-row>
      <v-col
        :cols="mobile() ? 11 : 4"
        class="d-flex justify-end mx-auto"
      >
        <SearchBarGlobal
          :space-id="spaceId"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col  
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? '' : 'mx-auto'">
        <p class="text-h5 font-weight-bold"
          align="left">
          {{ $t('workFlows') }}
        </p>
      </v-col>
    </v-row>

    <v-row v-if="!loadingData" align="center" class="mx-auto" data-testid="list-workflows" style="cursor: pointer">
      <v-col cols="11" class="mx-auto px-0">
        <v-row no-gutters class="pb-4">
          <v-col cols="12" md="2" class="px-6">
            <div class="text-body-2 grey--text justify-left">
              {{ $t('workflowName') }}
            </div>
          </v-col>
          <v-col cols="12" md="2" class="px-6 d-none d-md-block">
            <div class="text-body-2 grey--text justify-left">
              {{ $t('workfloMemberRequired') }}
            </div>
          </v-col>
          <v-col cols="12" md="2" class="px-6 d-none d-md-block">
            <div class="text-body-2 grey--text justify-left">
              {{ $t('amountOfParticipants') }}
            </div>
          </v-col>
          <v-col cols="12" md="2" class="px-6 d-none d-md-block">
            <div class="text-body-2 grey--text justify-left">
              {{ $t('workflowCreated') }}
            </div>
          </v-col>
          <v-col cols="12" md="2" class="px-6 d-none d-md-block">
            <div class="text-body-2 grey--text justify-left">
              {{ $t('workflowUpdated') }}
            </div>
          </v-col>
          <v-col cols="12" md="1" class="px-6 d-none d-md-block">
            <div class="text-body-2 grey--text justify-left">
              {{ $t('workflowStatus') }}
            </div>
          </v-col>

        </v-row>
        <v-divider style="border-width:1px" />
        <div v-if="workflows.length > 0">
          <div v-for="workflow in workflows" :key="workflow.id" :ripple="false" data-testid="workflow-item" rounded="xxl"
            class="solo" >
            <div class="py-2" v-if="mobile()" @click="showWorkflowDetail(workflow.id)">
              <v-row v-if="mobile()" no-gutters >
                <v-col cols="10" align-self="center" class="px-6">
                  <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate">
                    {{ workflow.attributes.title }}
                    <v-icon v-if="workflow.attributes.is_broken" color="error" class="ml-1">mdi-alert</v-icon>
                  </v-card-text>
                </v-col>
                <v-col cols="1" class="text-right d-flex align-center justify-end three-dots" v-if="workflow.attributes.is_owner">
                  <v-menu ref="menuRef" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="mr-1" icon v-bind="attrs" v-on="on">
                        <v-icon data-testid="threedots-icon" large>
                          mdi-dots-vertical
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list data-testid="menu-list">
                      <v-list-item data-testid="edit-workflow-item" router @click.stop="
                        selectedItem = workflow;
                        dialogVisibleWorkflow = true,
                        action = 'edit',
                        confirmationDialogTitleWithInputField = $t('confirmationDialogEditWorkflowTitle'),
                        confirmationDialogTextWithInputField = $t('confirmationDialogTextEditWorkflow'),
                        confirmationDialogInputPlaceholder = $t('confirmationDialogInputPlaceholderCreateWorkflow'),
                        confirmationDialogWithInputFieldSubmitBtn = $t('save')
                        confirmationDialogWithInputFieldCancelBtn = $t('cancel')">
                        <v-list-item-title>
                          {{ $t("edit") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item data-testid="duplicate-workflow-item" router @click.stop="
                        selectedItem = workflow,
                        dialogVisibleWorkflow = true,
                        action = 'duplicate',
                        confirmationDialogTitleWithInputField = $t('confirmationDialogTitleDuplicateWorkflow'),
                        confirmationDialogWithInputFieldSubmitBtn = $t('duplicate')
                        confirmationDialogWithInputFieldCancelBtn = $t('cancel')">
                        <v-list-item-title> {{ $t('duplicate') }} </v-list-item-title>
                      </v-list-item>
                      <v-list-item data-testid="delete-workflow-item" router @click.stop="
                        selectedWorkflowIdForDeletion = workflow.id,
                        dialogVisibleDeleteWorkflow = true,
                        confirmationDialogTitle = $t('confirmationDialogTitleDeleteWorkflow'),
                        confirmationDialogText = $t('confirmationDialogTextDeleteWorkflow'),
                        confirmationDialogSubmitBtn = $t('delete')
                        confirmationDialogCancelBtn = $t('no')">
                        <v-list-item-title> {{ $t('delete') }} </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>

              </v-row>

            </div>

            <div class="py-2" v-if="!mobile()">
              <v-row v-if="!mobile()" no-gutters @click="showWorkflowDetail(workflow.id)">
                <v-col cols="12" md="2" class="px-6" align-self="center">
                  <div class="text-body-1 darktext--text">
                    {{ workflow.attributes.title }}
                    <v-icon v-if="workflow.attributes.is_broken" color="error" class="ml-1">mdi-alert</v-icon>
                  </div>
                </v-col>
                <v-col cols="12" md="2" class="px-6" align-self="center">
                  <div class="text-body-1 darktext--text">
                    {{ workflow.attributes.member_type == "email" ? $t("notRequired") : $t("required") }}
                  </div>
                </v-col>

                <v-col cols="12" md="2" class="px-6" align-self="center">
                  <div class="text-body-1 darktext--text">
                    {{ workflow.attributes.participants_count }}
                  </div>
                </v-col>
              
                <v-col cols="12" md="2" class="px-6" align-self="center">
                  <div class="text-body-1 darktext--text">
                    {{ format_date(workflow.attributes.created_at) }}
                  </div>
                </v-col>
                <v-col cols="12" md="2" class="px-6" align-self="center">
                  <div class="text-body-1 darktext--text">
                    {{ format_date(workflow.attributes.updated_at) }}
                  </div>
                </v-col>
                <v-col cols="12" md="1" class="px-6">
                  <div class="d-flex justify-left mt-2" >
                    <v-switch data-testid="status-workflow" v-model="workflow.attributes.is_active" inset
                      @click.stop.prevent="editStatusWorkflow(workflow)"
                      color="success" class="mt-0 success--text" :disabled="workflow.attributes.is_broken">
                    </v-switch>
                    <v-alert data-testid="status-workflow-label" v-show="selectedID == workflow.id" transition="fade-transition" :class="workflow.attributes.is_active ? 'pa-0 ma-0 mt-1 success--text' : 'ma-0 pa-0 mt-1 grey--text'">
                      {{ workflow.attributes.is_active? $t('live') : $t('paused') }}
                    </v-alert>
                  </div>
                </v-col>
                <v-col cols="12" md="1" class="text-right d-flex align-center justify-end three-dots" v-if="workflow.attributes.is_owner">
                  <v-menu ref="menuRef" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="mr-4" icon v-bind="attrs" v-on="on">
                        <v-icon data-testid="threedots-icon" x-large>
                          mdi-dots-vertical
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list data-testid="menu-list">
                      <v-list-item data-testid="edit-workflow-item" router @click.stop="
                        selectedItem = workflow;
                        dialogVisibleWorkflow = true,
                        action = 'edit',
                      confirmationDialogTitleWithInputField = $t('confirmationDialogEditWorkflowTitle'),
                        confirmationDialogTextWithInputField = $t('confirmationDialogTextEditWorkflow'),
                        confirmationDialogInputPlaceholder = $t('confirmationDialogInputPlaceholderCreateWorkflow'),
                        confirmationDialogWithInputFieldSubmitBtn = $t('save')
                      confirmationDialogWithInputFieldCancelBtn = $t('cancel')">
                        <v-list-item-title>
                          {{ $t("edit") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item data-testid="duplicate-workflow-item" router @click.stop="
                        selectedItem = workflow,
                        dialogVisibleWorkflow = true,
                        action = 'duplicate',
                        confirmationDialogTitleWithInputField = $t('confirmationDialogTitleDuplicateWorkflow'),
                        confirmationDialogWithInputFieldSubmitBtn = $t('duplicate')
                        confirmationDialogWithInputFieldCancelBtn = $t('cancel')">
                        <v-list-item-title> {{ $t('duplicate') }} </v-list-item-title>
                      </v-list-item>
                      <v-list-item data-testid="delete-workflow-item" router @click.stop="
                        selectedWorkflowIdForDeletion = workflow.id,
                        dialogVisibleDeleteWorkflow = true,
                        confirmationDialogTitle = $t('confirmationDialogTitleDeleteWorkflow'),
                        confirmationDialogText = $t('confirmationDialogTextDeleteWorkflow'),
                        confirmationDialogSubmitBtn = $t('delete')
                        confirmationDialogCancelBtn = $t('no')">
                        <v-list-item-title> {{ $t('delete') }} </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>

              </v-row>

            </div>
            <v-divider />

          </div>
          <div
            data-testid="scroll-workflows"
            v-if="workflows.length"
            v-observe-visibility="handleScrolledToBottom"
            class="align-center d-flex justify-center"
          >
            <v-progress-circular
              data-testid="show-more-workflows"
              v-if="page.hasMore"
              size="24"
              color="primary"
              class="bottom py-5"
            />
          </div>

        </div>
        <div v-else style="margin-top: 15%">
          <v-row align="center" class="fill-height my-auto">
            <v-col cols="12" class="mx-auto px-0" data-testid="no-workflows">
              <v-row class="fill-height my-auto" align="center" justify="center">
                <v-col cols="12" sm="8" md="6" lg="6" align="center" class="greytextlight--text
                text-h6 text-md-h5
                font-weight-bold
                my-2
                pa-4
                d-flex flex-column justify-center align-center">
                  {{ $t("addWorkflowsMsg") }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-btn 
      v-if="(role == 'booster' || role == 'space_admin') && !mobile()" 
      elevation="2" 
      fixed 
      right 
      fab 
      bottom 
      large
      style="z-index: 99" 
      color="accent" 
      data-testid="create-workflow-button" 
      @click.stop="
        dialogVisibleSelectWorkflowType = true,
        action = 'createWorkflowType',
        confirmationDialogTitleWithInputField = $t('confirmationDialogTitleCreateWorkflow'),
        confirmationDialogTextWithInputField = $t('confirmationDialogTextCreateWorkflow'),
        confirmationDialogInputPlaceholder = $t('confirmationDialogInputPlaceholderCreateWorkflow'),
        confirmationDialogWithInputFieldSubmitBtn = $t('create')
        confirmationDialogWithInputFieldCancelBtn = $t('cancel')">
      <v-icon large>
        mdi-plus
      </v-icon>
    </v-btn>

    <CreateWorkflowTypeDialog 
      v-if="dialogVisibleSelectWorkflowType"
      ref="confirmationDialogWorkflowType"
      :visible="dialogVisibleSelectWorkflowType" 
      :action="action" 
      data-testid="select-workflow-type-dialog" 
      @close="dialogVisibleSelectWorkflowType = false"
      @proceedSubmit="processNextAction"
    />

    <ConfirmationDialogWithInputField 
      v-if="dialogVisibleWorkflow" 
      :visible="dialogVisibleWorkflow"
      :cd-title="confirmationDialogTitleWithInputField"
      :cd-text="confirmationDialogTextWithInputField"
      :cd-input-placeholder="confirmationDialogInputPlaceholder"
      :cd-submit-btn="confirmationDialogWithInputFieldSubmitBtn"
      :cd-cancel-btn="confirmationDialogWithInputFieldCancelBtn"
      data-testid="dialog-workflow"
      @close="dialogVisibleWorkflow = false, selectedItem = {}" 
      @proceedSubmit="createWorkflow" 
      @edit="editWorkflow"
      @duplicate="duplicateWorkflow"
      :item="selectedItem"
      :action="action" />

    <ConfirmationDialog 
      v-if="dialogVisibleDeleteWorkflow" 
      ref="confirmationDialogDeleteWorkflow"
      :visible="dialogVisibleDeleteWorkflow" 
      :cd-title="confirmationDialogTitle" 
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn" 
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog-delete-workflow" 
      @close="dialogVisibleDeleteWorkflow = false"
      @proceedSubmit="deleteWorkflow(selectedWorkflowIdForDeletion)" />

    
    <ConfirmationDialogWithOutSubmitBtn
      v-if="showConfirmationDialog"
      ref="showConfirmationDialog"
      :visible="showConfirmationDialog"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-additonal-text="confirmationDialogAdditonalText"
      @close="showConfirmationDialog = false"
    />
  </nav>
</template>
<script>
import ConfirmationDialogWithInputField from '../../components/ConfirmationDialogWithInputField'
import ConfirmationDialog  from '../../components/ConfirmationDialog'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages from "../../components/AlertMessages";
import i18n from '../../plugins/i18n'
import { createWorkflow, getWorkflows, updateWorkflowTitle, deleteWorkflow, duplicateWorkflow } from '../../api/workflowApi'
import { getSpaceByURL } from '../../api/spaceApi'
import ConfirmationDialogWithOutSubmitBtn from "../../components/ConfirmationDialogWithOutSubmitBtn";
import CreateWorkflowTypeDialog from "../../components/CreateWorkflowTypeDialog";
import DashboardHeader from '../../components/DashboardHeader'
import SearchBarGlobal from '../../components/SearchBarGlobal'

import moment from "moment";
export default {
  components: {
    ConfirmationDialogWithInputField,
    CreateWorkflowTypeDialog,
    ConfirmationDialog,
    AlertMessages,
    ConfirmationDialogWithOutSubmitBtn,
    DashboardHeader,
    SearchBarGlobal,
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      spaceId: window.$cookies.get('space_id'),
      role: localStorage.space ? JSON.parse(localStorage.space).role : '',
      dialogVisibleWorkflow: false,
      dialogVisibleSelectWorkflowType: false,
      nextAction: "",
      confirmationDialogTitleWithInputField: "",
      confirmationDialogTextWithInputField: "",
      confirmationDialogWithInputFieldCancelBtn: "",
      confirmationDialogWithInputFieldSubmitBtn: "",
      confirmationDialogInputPlaceholder: "",
      alertMsg: '',
      alertValue: false,
      alertType: '',
      title: '',
      workflows: [],
      pageNumber: 1,
      size: 15,
      loadingData: false,
      selectedItem: {},
      confirmationDialogTitle: '',
      confirmationDialogText: '',
      confirmationDialogCancelBtn: '',
      confirmationDialogSubmitBtn: '',
      dialogVisibleDeleteWorkflow: false,
      selectedWorkflowIdForDeletion: '',
      page: {},
      space: window.location.host.split('.')[0],
      action: '',
      selectedID: null,
      showConfirmationDialog:false,
      confirmationDialogAdditonalText : '',
      storeProducts:[],
      workflowType: null
    }
  },
  async created() {
    this.loadingData = true
    await this.fetchWorkflows()
    this.loadingData = false
  },
  methods: {
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },

    async processNextAction(event) {
      this.workflowType = event.type;
      this.dialogVisibleSelectWorkflowType = false;
      if (event.action == 'createWorkflowType') {
        this.dialogVisibleWorkflow = true;
      } else if(event.action == 'duplicate') {
        this.dialogVisibleWorkflow = true;
      }else if(event.action == 'edit') {
        this.dialogVisibleWorkflow = true;
      }
    },
    async createWorkflow(title) {
      this.dialogVisibleWorkflow = true
      try {
        let data = {
          data: {
            type: "workflows",
            attributes: {
              title: title.trim(),
              member_type: this.workflowType.trim(),
            },
            relationships: {
              space: {
                data: {
                  type: "spaces",
                  id: this.spaceId
                }
              }
            }

          }
        };
        var response = await createWorkflow(data);
        if (response) {
          if (response.status == 201) {
            this.$router.push({ path: '/workflow/' + response.data.data.id })
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true
          this.alertType = 'error'
          if (e.response.status == 422) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              this.alertValue = true;
              this.alertType = "error";
              this.alertMsg = e.response.data.errors[i].detail;
            }
          } else if (e.response.status == 403) {
            this.$router.push({ name: 'PageAccessDenied' })
          } else {
            this.alertMsg = i18n.t('serverError')
          }
        } else {
          this.alertType = 'error'
          this.alertValue = true
          this.alertMsg = i18n.t('serverError')
        }
      }

    },

    handleScrolledToBottom (isVisible) {
        if (!isVisible) {
          return
        }
        if (!this.page.hasMore) {
          return
        }
        this.fetchWorkflows()
      },  
    async fetchWorkflows() {
      
      try {
        const response = await getWorkflows(this.spaceId, this.size, this.page)
        if (response.status) {
          if (response.status == 200) {
            this.workflows.push(...response.data.data)
            this.page = response.data.meta.page
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertType = 'error'
          this.alertMsg = i18n.t('serverError')
        }
      }
    },

    showWorkflowDetail(id) {
      this.$router.push({ path: '/workflow/' + id })
    },

    async editWorkflow(title) {
      try {
        let data = {
          data: {
            type: "workflows",
            id: this.selectedItem.id,
            attributes: {
              title: title.trim()
            },
            relationships: {
              space: {
                  data: {
                      type: "spaces",
                      id: this.spaceId
                  }
              }
            }
          },
        };
        const response = await updateWorkflowTitle(this.selectedItem.id, data);
        if (response) {
          if (response.status == 200) {
            this.dialogVisibleWorkflow = false;
            this.page = {}
            const response = await getWorkflows(this.spaceId, this.workflows.length, this.page)
            this.workflows = response.data.data
            this.page = response.data.meta.page
            this.alertType = "success";
            this.alertMsg = i18n.t("updateWorkflowSuccessMsg");
            this.alertValue = true;
            this.selectedItem= {}
          }
        }
      } catch (e) {
        if (e.response) {
          this.dialogVisibleWorkflow = false;
          this.selectedItem= {}
          if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else if (e.response.status == 422) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              this.alertValue = true;
              this.alertType = "error";
              this.alertMsg = e.response.data.errors[i].detail;
            }
          } else {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t("serverError");
          }
        } else {
          this.alertValue = true
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
    },
      async editStatusWorkflow(item) {
      try {
          var data = {}
          if(item.attributes.is_active == true){
            data = {
              data: {
                type: "workflows",
                id: item.id,
                attributes: {
                  title: item.attributes.title.trim(),
                  is_active: true
                },
                relationships: {
                    space: {
                        data: {
                            type: "spaces",
                            id: this.spaceId
                        }
                    }
                }
              },
            };
          } else {
            data = {
              data: {
                type: "workflows",
                id: item.id,
                attributes: {
                  title: item.attributes.title.trim(),
                  is_active: false
                },
                relationships: {
                    space: {
                        data: {
                            type: "spaces",
                            id: this.spaceId
                        }
                    }
                }
              },
            };
          }
          const response = await updateWorkflowTitle(item.id, data);
          if (response && response.status == 200) {
            this.selectedID = item.id
            setTimeout(() => {
                this.selectedID = null;
            }, 3000);
          }
      } catch (e) {
        if (e.response) {
          this.selectedItem= {}
          if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t("serverError");
          }
        } else {
          this.alertValue = true
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
    },


    async deleteWorkflow(item){            

        this.dialogVisibleDeleteWorkflow = false;
        try {
            const response = await deleteWorkflow(item);
            if (response.status == 204) {
              this.confirmationDialogAdditonalText =''
            this.page = {}
            this.dialogVisibleWorkflow = false

            //check if broken status is fixed
            const response_space = await getSpaceByURL(this.space) 
            this.$store.dispatch("setBrokenWorkflow", response_space.data.data.attributes.workflow_warning)

            const response = await getWorkflows(this.spaceId, this.workflows.length, this.page)
            this.workflows = response.data.data
            this.page = response.data.meta.page
            this.alertType = "success";
            this.alertMsg = i18n.t("deletedWorkflowSuccessMsg");
            this.alertValue = true;
            }
        } catch (e) {
            if (e.response) {
            
                if (e.response.status == 403 && e.response.data.errors[0].detail == "It is not allowed to delete a workflow used in a product.") {
                      this.storeProducts = e.response.data.errors[0].meta.store_products;
                      this.confirmationDialogAdditonalText =''
                      this.showConfirmationDialogCanNotBeDeleted()
                }  else {
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                this.alertValue = true;
                }
            
            
            }
        }
    },
    showConfirmationDialogCanNotBeDeleted(){
           this.storeProducts.forEach(item => {
              this.confirmationDialogAdditonalText = this.confirmationDialogAdditonalText + '<p class="ml-5 mb-0 text-truncate">  -  '+ item + '</p>';
            });
          this.showConfirmationDialog= true
          this.confirmationDialogTitle= i18n.t('confirmationDialogTitleCanNotBeDeleted')
          this.confirmationDialogText= i18n.t('confirmationDialogTextCanNotBeDeleted')
    },
    async duplicateWorkflow(title){   
      try {
          let data = {
              data: {
                  type: "workflows",
                  id: this.selectedItem.id,
                  attributes: {
                      title: title.trim()
                  },
                  relationships: {
                      space: {
                          data: {
                              type: "spaces",
                              id: this.spaceId
                          }
                      },
                  }
              }
          }
          const response = await duplicateWorkflow(this.selectedItem.id, data);
          if (response.status == 201) {
            this.dialogVisibleWorkflow = false;
            this.page = {}
            const response = await getWorkflows(this.spaceId, this.workflows.length+1, this.page)
            this.workflows = response.data.data
            this.page = response.data.meta.page
            window.scrollTo(0,0)
            this.alertType = "success";
            this.alertMsg = i18n.t("duplicateWorkflowSuccess");
            this.alertValue = true;
            this.selectedItem= {}
            this.action = ''
          }
      } catch (e) {
        if (e.response) {
          this.dialogVisibleWorkflow = false;
          this.action = ''
          if (e.response.status == 403) {
              this.$router.push({ name: "PageAccessDenied" });
          } else if (e.response.status == 422) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              this.alertValue = true;
              this.alertType = "error";
              this.alertMsg = e.response.data.errors[i].detail;
            }
          } else {
              this.alertType = "error";
              this.alertMsg = i18n.t("serverError");
              this.alertValue = true;
          }
        }
      }
    },
  }
}
</script>
<style>
.v-input--switch.v-input--is-label-active label {
    color: var(--v-success-base) !important;
}
.v-input--switch label{
  color: var(--v-greytextlight-base) !important;
}
</style>